module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/bg_equipment_sp-6dd11b22fdfa07b7e562997da5003cd9.png";